/* TEMPORARY: companion to the manual header/footer copy from the
   learninglab site. Detects which learning portal the visitor came from
   (.com or .co.uk) so the header link and footer variant match it.
   Remove when this app moves inside the learning portal. */

const PORTAL_URLS = {
  com: 'https://www.hydropeptidelearninglab.com',
  uk: 'https://www.hydropeptidelearninglab.co.uk'
};

function detectPortal() {
  const param = /[?&]portal=(uk|com)\b/.exec(window.location.search);
  if (param) {
    return param[1];
  }

  const referrer = document.referrer || '';
  if (referrer.indexOf('hydropeptidelearninglab.co.uk') !== -1) {
    return 'uk';
  }
  if (referrer.indexOf('hydropeptidelearninglab.com') !== -1) {
    return 'com';
  }

  return null;
}

export function getPortal() {
  let portal = detectPortal();
  try {
    if (portal) {
      sessionStorage.setItem('portal', portal);
    } else {
      portal = sessionStorage.getItem('portal');
    }
  } catch (e) {
    // sessionStorage unavailable (e.g. blocked) - fall through to default
  }
  return portal || 'com';
}

export function getPortalUrl() {
  return PORTAL_URLS[getPortal()];
}
